export const classNameFromLocation = (locationPath: string = '') => {
  let locationClassName = locationPath;
  locationClassName = locationClassName.charAt(0) === '/' ? locationClassName.substring(1) : 'none';
  return `page-${locationClassName ? locationClassName.toLowerCase().replace(/\//g, '-') : 'notfound'}`;
};

export default classNameFromLocation;
